export type MbcSessionIds = {
  resourceId: string;
  threadId: string;
};

/**
 * Derives the Mastra resource and thread ids from a MySQL request id.
 *
 * Both fields carry the same string deliberately (D2): working memory is
 * thread-scoped, so a deterministic thread is what makes "one request, one
 * brief" true, and one value is easier to reason about than two that always
 * move together.
 *
 * Mirrored exactly in `apps/ai/src/mastra/features/mbc/lib/session-ids.ts` —
 * the two must never drift, or the frontend and the AI service will land the
 * same conversation under two different ids.
 */
export function mbcSessionIds(
  projectId: number,
  requestId: number,
): MbcSessionIds {
  return {
    resourceId: String(projectId),
    threadId: String(requestId),
  };
}

export function requestIdFromSessionId(id: string): null | number {
  const match = /^\d+$/.exec(id);

  return match ? Number(match[0]) : null;
}
